// Here, we place the variables that define important aspects of our application.
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SECONDS = 10;
export const RES_PER_PAGE = 10;
export const KEY = '46cb6435-edbb-4f11-bd6a-3dc96d6a4697';
export const MODAL_CLOSE_SEC = 2.5;
